import React from "react";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { safeDateTime } from "../../utils";
import { getAccountPromos } from "./accountPromoUtils";

export default function AccountPromoCell({ account }) {
  const pendingCode = account.pending_promo_code;
  const displayPromos = getAccountPromos(account);

  if (displayPromos.length === 0) {
    return (
      <Typography variant='body2' color='text.secondary'>
        {"—"}
      </Typography>
    );
  }

  return (
    <Stack spacing={0.75}>
      {displayPromos.map((promo) => (
        <Tooltip
          key={promo.id || promo.promo_code}
          title={
            <Stack spacing={0.5}>
              {promo.discount_type === "PERCENTAGE" &&
                promo.discount_value != null && (
                  <span>Code discount: {promo.discount_value}%</span>
                )}
              {promo.status && <span>Status: {promo.status}</span>}
              {promo.redeemed_at && (
                <span>Redeemed: {safeDateTime(promo.redeemed_at)}</span>
              )}
              {pendingCode === promo.promo_code && (
                <span>Signup is pending; the code is awaiting a subscription.</span>
              )}
              {account.subscription?.custom_discount_percent != null && (
                <span>
                  Current subscription discount: {account.subscription.custom_discount_percent}%
                </span>
              )}
            </Stack>
          }
        >
          <Stack direction='row' spacing={0.75} alignItems='center' tabIndex={0}>
            <Typography variant='body2' sx={{ whiteSpace: "nowrap" }}>
              {promo.partner_name ? `${promo.partner_name} · ` : ""}
              {promo.promo_code}
            </Typography>
            {pendingCode === promo.promo_code && (
              <Chip size='small' label='Pending signup' variant='outlined' />
            )}
          </Stack>
        </Tooltip>
      ))}
    </Stack>
  );
}
